export default __webpack_public_path__ + "static/footer-module-optimized-3029e25f0ff4e5c039d5e8d49c6391c4.svg";